export default __webpack_public_path__ + "static/media/W25P2004_05.e2a0b02e.png";